import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import { Input, Row, Card, Form, Col, Divider, Spin } from "antd";

//PROJECT IMPORTS
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../configurations.config";
import CustomButton from "../../../components/custom/CustomButton";

const EditGlobalConfiguration = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state } = useLocation();
  const [codeDetail, setConfigDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getDetalById();
  }, []);

  function getDetalById() {
    const url = `${apiConfig.Configurations}/${state.id}`;
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;

        useForm.setFieldsValue({
          stringValue: objList?.stringValue,
          value: objList?.value,
        });

        setConfigDetail();
      }
    });
    setIsLoading(false);
  }

  function onCancel() {
    navigate("/manage-config");
  }

  const onSubmit = (formValues) => {
    const url = `${apiConfig.Configurations}/${state.id}`;

    const params = {
      resourceType: "configurations",
    };

    const body = {
      ...formValues,
      method: "PUT",
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.editConfigurationMsg);
        navigate("/manage-config");
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.editConfiguration}
        pageItems={staticConfig.editConfigurationBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={useForm} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.value}
                  name="value"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.value),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.value)}
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.stringValue}
                  name="stringValue"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: BOM.CheckReqFld(labelConfig.stringValue),
                  //   },
                  // ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.stringValue
                    )}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Divider />
              {BOM.HasPermission("UPDATE_CONFIGURATION") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#15CCAE"
                  colorText="black"
                  hoverBackground="#4FECA0"
                />
              )}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default EditGlobalConfiguration;
